import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../../images/icononly_transparent_nobuffer.png';

export default function Footer() {
  return (
    <footer className="ss-footer">
      <div className="ss-container ss-footer__inner">
        <img src={logo} alt="Sustainably Sprouted" className="ss-footer__logo" />
        <div className="ss-footer__text">
          <p className="ss-footer__brand">© {new Date().getFullYear()} Sustainably Sprouted</p>
          <p className="ss-footer__tag">Thoughtfully Made Eco-friendly Products</p>
        </div>
        <nav className="ss-footer__links" aria-label="Footer">
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-use">Terms of Use</Link>
        </nav>
      </div>
    </footer>
  );
}
